/* eslint-disable no-console */

// This app used to ship a Workbox service worker that cached the app shell.
// It is gone, but browsers keep a registered worker alive until something
// unregisters it, so clients that installed it would otherwise keep serving
// stale assets forever. Tear down any leftover registration and its caches.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', async () => {
    try {
      const registrations = await navigator.serviceWorker.getRegistrations();
      if (!registrations.length) return;

      await Promise.all(registrations.map(registration => registration.unregister()));

      if ('caches' in window) {
        const keys = await caches.keys();
        await Promise.all(keys.map(key => caches.delete(key)));
      }

      console.log('Removed stale service worker and caches.');
    } catch (error) {
      console.error('Failed to remove stale service worker:', error);
    }
  });
}
